
import { computed, defineComponent, ref } from 'vue';
import BanIcon from '@/components/ui-elements/icons/BanIcon.vue';
import BudgetModal from '@/components/modals/BudgetModal.vue';
import Button from '@/components/ui-elements/form/Button.vue';
import Card from '@/components/ui-elements/card/Card.vue';
import CardContent from '@/components/ui-elements/card/CardContent.vue';
import CardHeader from '@/components/ui-elements/card/CardHeader.vue';
import ChevronDownIcon from '@/components/ui-elements/icons/ChevronDownIcon.vue';
import ConfirmationModal from '@/components/modals/ConfirmationModal.vue';
import CustomBudgetModal from '@/components/modals/CustomBudgetModal.vue';
import EditIcon from '@/components/ui-elements/icons/EditIcon.vue';
import FireIcon from '@/components/ui-elements/icons/FireIcon.vue';
import Select from '@/components/ui-elements/form/Select.vue';
import SideBar from '@/components/partials/SideBar.vue';
import SubNav from '@/components/partials/SubNav.vue';
import SubNavItems from '@/components/partials/SubNavItems.vue';
import TrendDownIcon from '@/components/ui-elements/icons/TrendDownIcon.vue';
import TrendUpIcon from '@/components/ui-elements/icons/TrendUpIcon.vue';
import WarningIcon from '@/components/ui-elements/icons/WarningIcon.vue';
import { useBudgetStore } from '@/store';
import { useRouter } from 'vue-router';
import useCurrency from '@/hooks/useCurrency';
import useRemoveExpense from '@/hooks/useRemoveExpense';
import useUtils from '@/hooks/useUtils';
import { useAggregationStore } from '@/store';
import YTDSummary from '@/components/partials/YTDSummary.vue';

export default defineComponent({
	components: {
		BanIcon,
		BudgetModal,
		Button,
		Card,
		CardContent,
		CardHeader,
		ChevronDownIcon,
		ConfirmationModal,
		CustomBudgetModal,
		EditIcon,
		FireIcon,
		Select,
		SideBar,
		SubNav,
		SubNavItems,
		TrendDownIcon,
		TrendUpIcon,
		WarningIcon,
		YTDSummary,
	},
	setup() {
		const { arrayColumn } = useUtils();
		const { push } = useRouter();
		const {
			getRemoveExpenseList,
			removeExpense,
			resetList,
			setItemToBeRemoved,
		} = useRemoveExpense();
		const { formatDollar } = useCurrency();
		const budgetStore = useBudgetStore();
		const aggregationStore = useAggregationStore();

		const addBudgetItems = [
			{ value: 'monthly', label: 'Monthly Budget', icon: 'CalendarIcon' },
			{ value: 'blank', label: 'Blank Budget', icon: 'ArchiveIcon' },
		];
		const showAddBudgetNav = ref(false);
		const showBudgetModal = ref(false);
		const showCustomBudgetModal = ref(false);
		const budgets = computed(() => budgetStore.sortedBudgets);
		const selectedYear = ref('');
		const showConfirmModal = ref(false);
		const maxSaved = computed(() => {
			return Math.max(
				...arrayColumn(
					'saved',
					(budgets.value as any)[selectedYear.value]
				).map(val => Number(val))
			).toString();
		});

		const years = computed(() => {
			const allYears = aggregationStore.allYears;

			if (selectedYear.value === '' && allYears.length) {
				selectedYear.value = allYears[0].value;
			}

			return allYears;
		});

		const confirmRemoveBudget = () => {
			const { save } = removeExpense(
				budgets.value as Record<string, Array<any>>
			);

			if (save) {
				budgetStore.removeBudgets(getRemoveExpenseList()[0]);
				resetList();
			}
		};

		const goToEditPage = (id: string) =>
			push({ name: 'budget-edit', params: { id } });

		const goToTemplatePage = () => push({ name: 'budget-template' });

		const handleNavClick = (e: string) => {
			if (e === 'monthly') {
				showBudgetModal.value = true;
			}

			if (e === 'blank') {
				showCustomBudgetModal.value = true;
			}
		};

		const setDeleteAndShowConfirmation = (id: string | number) => {
			setItemToBeRemoved({ id, category: selectedYear.value });
			showConfirmModal.value = true;
		};

		return {
			addBudgetItems,
			confirmRemoveBudget,
			showAddBudgetNav,
			budgets,
			formatDollar,
			goToEditPage,
			goToTemplatePage,
			handleNavClick,
			maxSaved,
			selectedYear,
			setDeleteAndShowConfirmation,
			showBudgetModal,
			showConfirmModal,
			showCustomBudgetModal,
			years,
		};
	},
});
